import * as _ from 'lodash';

export default function group(data, property = 'group_code') {

  let collection = []

  _.chain(data).groupBy(property).map((groups, key) => {

    groups.map(item => {
      if (!key) collection.push({ product: item, products: [] })
    })

    if (key) {
      let sorted = groups.sort((a,b) => parseFloat(a.price) - parseFloat(b.price))
      collection.push({ product: sorted[0], products: sorted })
    }

  }).value()

  return collection.sort((a,b) => parseFloat(a.product.price) - parseFloat(b.product.price));
}